<main class="dashboard admin-layout">
  <div class="dashboard__block">
    <div class="dashboard__container">
      <app-sidebar [isOpen]="displaySidebar" (closeSidebar)="toggleSidebar()"></app-sidebar>

      <div class="dashboard__content">
        <app-header (toggleSidebar)="toggleSidebar()"></app-header>

        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</main>
